import request from '@/services/request'
import { IUserMe } from '@/types/user'
import { useQuery } from '@tanstack/react-query'

export const useGetMe = (enabled = true) => {
  return useQuery<IUserMe>({
    queryKey: ['user-me'],
    queryFn: async () => {
      const response = await request.private.get('users/v2/me/')
      return response.data
    },
    enabled,
  })
}
